export default __webpack_public_path__ + "static/media/02(2)@2x.f0226621.png";